import { render, staticRenderFns } from "./FileRenameDialog.vue?vue&type=template&id=6204e0cd&scoped=true&"
import script from "./FileRenameDialog.vue?vue&type=script&lang=ts&"
export * from "./FileRenameDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204e0cd",
  null
  
)

export default component.exports